import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0B1F3A] text-[#FFF9E6] mt-16 md:mt-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10 md:py-16 grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="brand-mark items-start mb-3" style={{ alignItems: "flex-start" }}>
            <span className="brand-nisa text-4xl md:text-5xl" style={{ color: "#F8A5C2" }}>Nisa</span>
            <span className="brand-underline" style={{ background: "#F8A5C2", width: "80%", marginLeft: 0 }} />
            <span className="brand-libas text-[10px] md:text-xs">LIBAS</span>
          </div>
          <p className="text-sm text-[#FFF9E6]/70 leading-relaxed">Heritage handloom · Modern silhouettes · Editorial fashion for women and kids across India.</p>
        </div>
        <div>
          <div className="eyebrow mb-4">Shop</div>
          <ul className="space-y-2 text-sm text-[#FFF9E6]/70">
            <li><Link to="/shop/women" data-testid="footer-women">Women</Link></li>
            <li><Link to="/shop/kids" data-testid="footer-kids">Kids</Link></li>
            <li><Link to="/shop?featured=true" data-testid="footer-featured">Featured</Link></li>
            <li><Link to="/track" data-testid="footer-track">Track Order</Link></li>
          </ul>
        </div>
        <div>
          <div className="eyebrow mb-4">Support</div>
          <ul className="space-y-2 text-sm text-[#FFF9E6]/70">
            <li>Free shipping across India</li>
            <li>7-day returns</li>
            <li>Made-to-order available</li>
            <li>Care instructions</li>
          </ul>
        </div>
        <div>
          <div className="eyebrow mb-4">Connect</div>
          <div className="flex gap-3">
            <a href="https://wa.me/919100042473" target="_blank" rel="noreferrer" className="w-10 h-10 bg-[#25D366] flex items-center justify-center text-[#0B1F3A]" data-testid="footer-wa"><MessageCircle size={18} /></a>
            <a href="mailto:hello@nisalibas.com" className="w-10 h-10 bg-[#D4AF37] flex items-center justify-center text-[#0B1F3A]" data-testid="footer-mail"><Mail size={18} /></a>
            <a href="#" className="w-10 h-10 border border-[#D4AF37]/50 flex items-center justify-center" data-testid="footer-ig"><Instagram size={18} /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-[#D4AF37]/20 py-5 text-center text-xs text-[#FFF9E6]/50">© 2026 Nisa Libas · Crafted in India with love</div>
    </footer>
  );
}
